export const blockIconsTransportationDirectionsBusNew = (
	<span className='material-symbols-outlined'>directions_bus</span>
);
